import { GTAG, JUNE_SO } from "@stadium/services/analytics/constants/services";

export const PREVIEW_MODE = "preview-mode";
export const USE_TEMPLATE = "use-template";
export const GET_A_QUOTE = "get-a-quote";
export const GENERATE_QUOTE_CTA = "generate-quote";
export const QUOTE_ESTIMATE = "quote-estimate";
export const START_AN_ORDER_CTA = "start-an-order";
export const DOWNLOAD_PDF_CTA = "download-pdf";
export const OFFERINGS = "offerings";
export const BACK_CTA = "back";
export const GET_STARTED_CTA = "get-started";
export const CREATE_BUNDLE = "create-a-bundle";
export const ADD_TO_BUNDLE = "add-to-bundle";
export const BAG_ICON = "bag";
export const NEXT_CTA = "next";
export const CHOOSE_ITEMS = "choose-items";
export const COUNTRY_FLAG = "country-flag";
export const VIEW_AND_SEND = "view-and-send";
export const SHOP_CART_GET_A_QUOTE_MODAL = "shop-cart-get-a-quote-modal";
export const EMAIL_QUOTE = "email-quote";
export const CALCULATE_FULFIILLMENT_FEE = "calculate-fulfillment-fee";
export const DONE = "done";
export const CLOSE = "close";
export const DOWNLOAD_QUOTE = "download-quote";
export const SWAG_CATALOG = "swag-catalog";
export const SPEAK_WITH_AN_EXPERT = "speak-with-an-expert";
export const CATALOG_PAGE = "catalog-page";
export const SHOP_CATALOG_MODE = "shop-catalog-mode";
export const CREATE_SHOP = "shop";
export const SHOP_FRONT = "shop-front";
export const SEND_TO_MYSELF = "send-to-myself";
export const SEND_TO_OTHER = "send-to-other";
export const YOUR_BAG = "your-bag";
export const YOUR_BAG_SELF = "your-bag-self";
export const YOUR_BAG_OTHER = "your-bag-other";
export const NEXT = "next";
export const BAG_SELECT_SHIPPING_SELF = "bag-select-shipping-self";
export const BAG_SELECT_PAYEMENT_SELF = "bag-select-payment-self";
export const CONTINUE_TO_PAYMENT = "continue-to-payment";
export const PAY_NOW = "pay-now";
export const SHOP_CREATION = "shop-creation";
export const PRICELESS_SHOP = "priceless-shop";
export const MENU_CATALOG_SELECTION = "menu-catalog-selection";
export const PRICING_PAGE = "pricing-page";
export const KIT_UNAVAILABLE = "kit-unavailable";
export const CART = "cart";
export const REQUEST_MOCKUP_BUTTON = "request-mockup-button";
export const REQUEST_MOCKUP_MODAL = "request-mockup-modal";
export const DEFAULT_SERVICES = Object.freeze([JUNE_SO]);

export const GET_A_QUOTE_PAGE_SERVICES = [...DEFAULT_SERVICES, GTAG];
export const QUOTE_ESTIMATE_PAGE_SERVICES = [...DEFAULT_SERVICES, GTAG];
export const OFFERINGS_FLOW_SERVICES = [...DEFAULT_SERVICES, GTAG];
export const PRICELESS_FLOW = DEFAULT_SERVICES;
export const SHOP_CREATION_FLOW = DEFAULT_SERVICES;
export const WIDGET_SERVICES = [...DEFAULT_SERVICES, GTAG];
export const REQUEST_MOCKUP_SERVICES = [...DEFAULT_SERVICES, GTAG];
